export const DEPTS = [
  '영업1팀',
  '영업2팀',
  '기획팀',
  '경영혁신팀',
  '신센터TF',
  '일동제약컨설팅TF',
  'AX실',
  '경영지원팀',
];

export const DEPT_ALIAS = { DX본부: 'AX실', 운영팀: '경영혁신팀' };

export const MAX_ATTACHMENTS_PER_REPORT = 20;
export const MAX_ATTACHMENT_BYTES = 100 * 1024 * 1024;
export const MAX_REPORT_ATTACHMENT_BYTES = 100 * 1024 * 1024;

export const RICH_FIELDS = [
  't1i1',
  't1i2',
  't2i1',
  't2i2',
  't3i1',
  't3i2',
  'ai_usage',
  'etc',
];

export function sortByDeptOrder(arr, getKey = (item) => item) {
  const order = new Map(DEPTS.map((dept, index) => [dept, index]));
  return (arr || [])
    .map((item, index) => ({ item, index }))
    .sort((left, right) => {
      const leftKey = DEPT_ALIAS[getKey(left.item)] || getKey(left.item);
      const rightKey = DEPT_ALIAS[getKey(right.item)] || getKey(right.item);
      const byDept = (order.get(leftKey) ?? 999) - (order.get(rightKey) ?? 999);
      return byDept || left.index - right.index;
    })
    .map(({ item }) => item);
}
